import { MenuConfigModel } from '@core/models/outros/menu-config.model';
import { ROUTES_APLICATION } from '@constants/routes-aplication.constants';
import { UserTypeEnum } from '@enums/user-type.enum';
import { ApplicationModules } from '@enums/application-modules.enum';

export const MENU_PRACTICAL_COURSE: MenuConfigModel = {
  id: ApplicationModules.PRACTICAL_COURSE,
  icon: 'sports_motorsports',
  name: 'Curso Prático',
  onlyAssociated: true,
  text: 'Organize a agenda das <strong>aulas práticas</strong>.',
  profilesToShowItems: [
    UserTypeEnum.ADMINISTRADOR,
    UserTypeEnum.OPERADOR_N1,
    UserTypeEnum.INSTRUTOR,
    UserTypeEnum.SUPERVISOR
  ],
  submenus: [    
    {
      name: 'Mapa de Horas',
      onlyAssociated: true,
      profilesToShowItems: [
        UserTypeEnum.ADMINISTRADOR,
        UserTypeEnum.SUPERVISOR,
        UserTypeEnum.OPERADOR_N1
      ],
      route: `/${ROUTES_APLICATION.practical_course.path}/${ROUTES_APLICATION.practical_course.timeMap}`,
    },    
    {
      name: 'Disponibilidade de Veículo',
      onlyAssociated: true,
      profilesToShowItems: [
        UserTypeEnum.ADMINISTRADOR,
        UserTypeEnum.SUPERVISOR,
        UserTypeEnum.OPERADOR_N1
      ],
      route: `/${ROUTES_APLICATION.practical_course.path}/${ROUTES_APLICATION.practical_course.vehicleAvailability}`,
    },
    {
      name: 'Bloqueio de Disponibilidade',
      onlyAssociated: true,
      profilesToShowItems: [
        UserTypeEnum.ADMINISTRADOR,
        UserTypeEnum.SUPERVISOR,
        UserTypeEnum.OPERADOR_N1
      ],
      route: `/${ROUTES_APLICATION.practical_course.path}/${ROUTES_APLICATION.practical_course.vehicleAvailabilityBlock}`,
    },
    {
      name: 'Agendamento',
      onlyAssociated: true,
      profilesToShowItems: [
        UserTypeEnum.ADMINISTRADOR,
        UserTypeEnum.SUPERVISOR,
        UserTypeEnum.OPERADOR_N1,
      ],
      route: `/${ROUTES_APLICATION.practical_course.path}/${ROUTES_APLICATION.practical_course.practical}`,
    },
  ],
}
